<script setup>
  const {} = defineProps({
    autowrap: Boolean,
    wide: Boolean,
    full: Boolean,
  });
</script>

<!----------------------------------------------------------------------------->

<template>
  <section>
    <Grid v-if="autowrap" :wide="wide" :full="full">
      <slot />
    </Grid>
    <slot v-else />
  </section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    position: relative;
    padding: $block-padding-small 0;

    @include break-medium {
      padding: $block-padding-extra-small 0;
    }
  }
</style>
